var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3764",
    "data-name": "Rectangle 3764",
    width: 12,
    height: 14,
    transform: "translate(0.225 0.115)",
    fill: "#003049"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10824",
    "data-name": "Group 10824",
    transform: "translate(-0.498 -0.115)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10823",
    "data-name": "Group 10823",
    transform: "translate(0.273)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28026",
    "data-name": "Path 28026",
    d: "M9.7,14.23H3.234A1.943,1.943,0,0,1,1.294,12.29V3.881H.647a.647.647,0,1,1,0-1.294H3.234V1.941A1.943,1.943,0,0,1,5.175,0H7.762A1.943,1.943,0,0,1,9.7,1.941v.647H12.29a.647.647,0,1,1,0,1.294h-.647V12.29A1.943,1.943,0,0,1,9.7,14.23M2.587,3.881V12.29a.647.647,0,0,0,.647.647H9.7a.647.647,0,0,0,.647-.647V3.881ZM4.528,2.587H8.409V1.941a.647.647,0,0,0-.647-.647H5.175a.648.648,0,0,0-.647.647ZM7.762,11a.646.646,0,0,1-.647-.647V6.468a.647.647,0,1,1,1.294,0v3.881A.646.646,0,0,1,7.762,11M5.175,11a.647.647,0,0,1-.647-.647V6.468a.647.647,0,1,1,1.294,0v3.881A.647.647,0,0,1,5.175,11",
    transform: "translate(-0.243)",
    fill: "#003049"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.aed743d09d6078385bbe447f78d5325c.svg";
export { ForwardRef as ReactComponent };